import { PointData } from "pixi.js";
import { GameMouseEvent, getTargetCoordsNormalized } from "./Game";


export class Mouse {
	public mouseEvents = [] as GameMouseEvent[];

	public mouseClicked?: PointData;
	public mouseMoved?: PointData;
	public lastMouseLocation = {
		x: 0, y: 0
	} as PointData

	public onMouseDown(event: any): void {
		this.mouseEvents.push({
			type: 'down',
			point: getTargetCoordsNormalized(event)
		});
	}

	public onMouseMove(event: any): void {
		this.mouseEvents.push({
			type: 'move',
			point: getTargetCoordsNormalized(event)
		});
	}

	tick() {
		this.mouseClicked = this.mouseEvents.find(e => e.type === 'down')?.point;
		this.mouseMoved = this.mouseEvents.find(e => e.type === 'move')?.point;
		if (this.mouseEvents.length)
			this.lastMouseLocation = this.mouseEvents[this.mouseEvents.length - 1].point
		this.mouseEvents = [];
	}
}
